import { render, staticRenderFns } from "./mobileDeclination1.vue?vue&type=template&id=5023ba80&"
import script from "./mobileDeclination1.vue?vue&type=script&lang=ts&"
export * from "./mobileDeclination1.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports